<template>
  <custom-dialog width="800px" :title="title" v-on="$listeners" :visible="visible" class="img-detail-dialog" :append-to-body="true">
    <div class="dialog-body">
      <ul class="img-list">
        <li v-for="(item, index) in imgList" :key="index">
          <template v-if="isMP4(getAttachUrl(item))">
            <video :src="getAttachUrl(item)" controls="controls" class="video"></video>
          </template>
          <template v-else>
            <img :src="getAttachUrl(item)" />
          </template>
        </li>
      </ul>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';



export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    // 没有img地址的数据
    bizData: {
      type: Array,
      default() {
        return [];
      },
    },
    // 已经有img地址的数据
    imgData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    imgList() {
      if (this.imgData && this.imgData.length) {
        return this.imgData;
      }
      return this.list;
    },
  },
  data() {
    return {
      visible: true,
      list: [],
    };
  },
  methods: {
    // 是map4资源
    isMP4(sourcePath) {
      const pattern = /\.mp4$/;
      return pattern.test(sourcePath);
    },
    getList() {
      const promiseList = [];
      this.bizData.forEach((item) => {
        const p = this.$getJSON(`${apis.OssAttach}/${item.bizId}/${item.bizType}`);
        promiseList.push(p);
      });
      Promise.all(promiseList).then((resList) => {
        const list = resList.map(res => res.data);
        const ret = [];
        list.forEach((arr) => {
          ret.push(...arr);
        });
        this.list = ret;
      });
    },
  },
  mounted() {
    if (!this.imgData || !this.imgData.length) {
      this.getList();
    }
  },
};
</script>

<style lang="scss">
.img-detail-dialog {
  .dialog-body {
    overflow-y: auto;
    height: 600px;

    .img-list {
      > li {
        margin-bottom: 15px;
      }
      img {
        width: 100%;
      }
      .video{
        width: 100%;
      }
    }
  }
}
</style>
